import React, { useEffect, useState } from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';

const COUNTDOWN_LENGTH = 30;

type OTPTimerProps = {
  sentToLabel: 'メール' | '自動音声案内';
  onPress: () => void;
};

const OTPTimer = (props: OTPTimerProps) => {
  const [countdownTick, setCountdownTick] = useState(COUNTDOWN_LENGTH);
  const [isOTPRequested, setIsOTPRequested] = useState(false);

  useEffect(() => {
    let timer: number;

    if (countdownTick) {
      // https://github.com/Microsoft/TypeScript/issues/30128#issuecomment-807394387
      timer = +global.setTimeout(() => {
        setCountdownTick(countdownTick - 1);
      }, 1000);
    }

    return () => clearTimeout(timer);
  });

  const onOTPInvoke = async () => {
    setIsOTPRequested(true);
    setCountdownTick(COUNTDOWN_LENGTH);
    props.onPress();
  };

  return (
    <View>
      <Text style={style.textItem}>
        {countdownTick
          ? `${countdownTick}秒以内に届かない場合`
          : '届いていませんか？'}
      </Text>
      <TouchableOpacity
        disabled={!isOTPRequested ? !!countdownTick : false}
        onPress={onOTPInvoke}
      >
        <Text
          style={[
            style.textItem,
            countdownTick && !isOTPRequested
              ? style.textItemDisabled
              : style.textItemPressable,
          ]}
        >
          {isOTPRequested
            ? `${props.sentToLabel}で受け取る`
            : `${props.sentToLabel}で認証コードを受け取る`}
        </Text>
      </TouchableOpacity>
    </View>
  );
};

const style = StyleSheet.create({
  textItem: {
    textAlign: 'center',
    fontSize: 12,
    marginTop: 8,
  },
  textItemDisabled: {
    color: '#A1AAB0',
  },
  textItemPressable: {
    fontWeight: '500',
  },
});

export default OTPTimer;
